export default "__VITE_ASSET__BLWFCbia__"